import { render, staticRenderFns } from "./BCardActions.vue?vue&type=template&id=56436a0b&scoped=true&"
import script from "./BCardActions.vue?vue&type=script&lang=js&"
export * from "./BCardActions.vue?vue&type=script&lang=js&"
import style0 from "./BCardActions.vue?vue&type=style&index=0&id=56436a0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56436a0b",
  null
  
)

export default component.exports